<div class="card-body">

  <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
  <button *ngIf="!InProccessing" (click)="Read_Activity()" type="button" class="btn btn-info" style="margin-left: 5px;"><i
      class="fa  fa-search"></i> جستجوی اطلاعات</button>

  <br>
  <br>

  <div class="table-responsive">
    <table class="mb-0 table table-bordered table-3 text-center table-striped">
      <thead style="background-color: #489b39; color: white;">
        <tr>
          <th>#</th>
          <th>نماینده کالیبراسیون</th>
          <th>راه ارتباطی</th>
          <th>خلاصه گفتگو</th>
          <th>کاربر</th>
          <th>تاریخ</th>
          <th>امکانات</th>
        </tr>
      </thead>
      <tbody>

        <ng-container *ngFor="let item of DataList_Activity">


          <tr>

            <td>{{DataList_Activity.indexOf(item)+1}}</td>
            <td>{{item.karshnas_masol_name}}</td>
            <td>{{item.link_dsc}}</td>
            <td>{{item.dsc}}</td>
            <td>{{item.create_username}}</td>
            <td>{{item.create_subdate}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" class="dropdown-item" (click)="openModalRemove(template,item)"><i class="fa fa-remove"></i> حذف </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>

          <tr *ngIf="item.file.length>0">
            <td colspan="7">
              <div class="table-responsive">
                <table class="mb-0 table table-bordered table-3 text-center table-striped">
                  <thead style="background-color: #3e399b; color: white;">
                    <tr>
                      <th>#</th>
                      <th>فایل</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let itemFile of item.file">

                      <td>{{item.file.indexOf(itemFile)+1}}</td>
                      <td>

                        <a target="_blank" *ngIf="itemFile.includes('.pdf')"
                          href="{{BaseURlFile}}File/Letter/{{itemFile}}" class="btn btn-success"><i
                            class="fa fa-file-pdf-o"></i> PDF </a>


                        <img *ngIf="!itemFile.includes('.pdf')" (click)="openModal(templateImage,itemFile)"
                          style="width: 150px;cursor: zoom-in;" src="{{BaseURlFile}}File/Letter/{{itemFile}}" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>

        </ng-container>

      </tbody>
    </table>
  </div>


</div>


<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> نمایش عکس </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseURlFile}}File/Letter/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseURlFile}}File/Letter/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> دانلود </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">تایید حذف  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> حذف اطلاعات <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>